import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ImageData {
  titlePrefix: string;
  title: string;
  imageUrl: string;
}

@Component({
  selector: 'app-expanded-image',
  templateUrl: './expanded-image.component.html',
  styleUrls: ['./expanded-image.component.scss'],
  standalone: false,
})
export class ExpandedImageComponent {
  imageData = inject<ImageData>(MAT_DIALOG_DATA);
}
